import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

const values = [
  {
    icon: "ri-compass-3-line",
    title: "便捷的内容发现",
    desc: "通过分类筛选、关键词搜索与相关推荐，帮助你在最短时间内找到想看的影视内容。",
  },
  {
    icon: "ri-time-line",
    title: "及时的更新信息",
    desc: "持续维护内容库，标注上映 / 连载状态与更新时间，让你随时掌握最新动态。",
  },
  {
    icon: "ri-shield-check-line",
    title: "清晰的展示体验",
    desc: "界面简洁、层级清晰，所有内容信息均以可检索文本呈现，浏览流畅不打扰。",
  },
];

export default function AboutPage() {
  return (
    <div className="mx-auto max-w-site px-4 py-10 md:px-6 md:py-14">
      <header className="mb-10">
        <p className="font-heading text-sm font-medium text-primary-600">关于我们</p>
        <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          {siteInfo.brand}
        </h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">
          {siteInfo.intro}
        </p>
      </header>

      <section className="mb-12 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {siteInfo.stats.map((stat) => (
          <div
            key={stat.label}
            className="rounded-lg border border-background-200 bg-background-100 p-5"
          >
            <p className="font-heading text-2xl font-bold text-primary-600">{stat.value}</p>
            <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
          </div>
        ))}
      </section>

      <section className="mb-12">
        <h2 className="mb-5 font-heading text-xl font-bold text-foreground-950">运营宗旨</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {values.map((value) => (
            <div
              key={value.title}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${value.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {value.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-12 grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">内容来源说明</h2>
          <div className="space-y-3 text-sm leading-relaxed text-foreground-700">
            <p>{siteInfo.introDetail}</p>
            <p className="rounded-md border border-accent-200 bg-accent-50 p-4 text-accent-900">
              {siteInfo.copyright}本平台不存储、不传播任何影视资源，播放功能仅作界面演示。
            </p>
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="mb-4 font-heading text-xl font-bold text-foreground-950">联系方式</h2>
          <p className="text-sm leading-relaxed text-foreground-600">
            如果你对内容分类、功能体验有建议，或发现信息有误，欢迎通过以下方式联系我们，我们会认真对待每一条反馈。
          </p>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center gap-3 text-foreground-800">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-mail-line" />
              </span>
              {siteInfo.email}
            </li>
            <li className="flex items-center gap-3 text-foreground-800">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-time-line" />
              </span>
              服务时间：{siteInfo.workingHours}
            </li>
          </ul>
        </div>
      </section>

      <section>
        <h2 className="mb-5 font-heading text-xl font-bold text-foreground-950">内容分类导航</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.type}
              to={`/category/${cat.type}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600">
                  {cat.name}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-600">{cat.shortName}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}